import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';


require('./bootstrap');
require('./sidebar');
require('./menu');
require('./data_tables.js');
require('./modelos.js');


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

import Glide from "@glidejs/glide";
import { DropdownHeader } from "./functionalities/DropdownHeader";
// require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/App');

new DropdownHeader('.nav', '.containerCollapse');

var sliderPlanes = document.querySelector(".sliderPlanes");
if (sliderPlanes) {

        new Glide(sliderPlanes, {
            gap: 0,
            animationDuration: 300,
            perView: 3,
            bound: true,
            breakpoints: {
                600: {
                    perView: 1
                },
                900: {
                    perView: 2
                },
                992: {
                    perView: 3
                }
            }
        }).mount();

};


